import { i18n } from '@fs/zion-locale'
import * as Yup from 'yup'

const relationshipsShape = Yup.array().of(
  Yup.object().shape({
    relationship: Yup.object().required(i18n.t('FormValidation.notEmpty', 'Field cannot be empty.')),
  })
)

// Use to validate the Household Details form in the main card
export const householdDetailsValidationSchema = Yup.object().shape({
  household: Yup.object().nullable(),
  relationships: Yup.array().of(
    Yup.object().shape({
      relationship: Yup.object().required(i18n.t('FormValidation.selectOption', 'Select an option from the list')),
    })
  ),
})

// Use to validate the Previous Relationships dialog form
export const previousRelationshipsValidationSchema = Yup.object().shape({
  relationships: relationshipsShape,
})
